import ferretWrite from "../assets/ferretwrite.gif";
import poohWrite from "../assets/poohwrite.gif";
import girlWrite from "../assets/girlWrite.gif";

export default function Home() {
    return (
        <div className="container">
            <h3 style={{ fontSize: "1.5em" }}>welcome to...</h3>
            <h2 style={{ marginLeft: "10px", fontSize: "2em" }}>grace's blog!</h2>
            <div className="innerContainer">
                <p>real life images of me writing my posts:</p>
                <div>
                    <img src={ferretWrite} alt="ferret writing at a desk" />
                    <img
                        src={poohWrite}
                        alt="winnie the pooh laying down, writing with a quill and ink"
                    />
                    <img src={girlWrite} alt="girl writing at a desk" />
                </div>
                <p>
                    (sourced from{" "}
                    <a href="https://gifcities.org/" target="_blank" rel="noreferrer">
                        gif cities
                    </a>
                    )
                </p>
                <hr style={{ border: "1px solid var(--text)" }} />
                <h3 style={{ fontSize: "1.5em" }}>ABOUT ME</h3>
                <p style={{ marginTop: "5px" }}>
                    I am a software developer and web enthusiast in San Diego, CA, USA. Sometimes I
                    have thoughts! And this is where they will live if I wish to make them public.
                    :)
                </p>
                <p>
                    It's likely that you arrived here from my{" "}
                    <a href="https://graces-portal.net/">portal</a>. If you found this website some
                    other way, welcome! Make yourself at home.
                </p>
            </div>
        </div>
    );
}
